/*
 * Created Date: Friday, December 9th 2022
 * Author: Vive Vio Permana
 * 
 * Custom hook for getting params from address bar
 */

import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const useQueryParamHooks = () => {
    let { search } = useLocation();
    return useMemo(()=> new URLSearchParams(search), [search])
}

export default useQueryParamHooks
